{
  "kind": {
    "pdf": "PDF",
    "document": "Document",
    "image": "Image",
    "presentation": "Presentation",
    "other": "File"
  },
  "scope": {
    "schoolWide": "Whole school"
  },
  "list": {
    "title": "Library",
    "description": "Books, documents and materials shared with your school.",
    "searchPlaceholder": "Search by title, author or tag…",
    "kindFilter": "Type",
    "anyKind": "Any type",
    "classFilter": "Class",
    "anyClass": "Any class",
    "schoolWideOnly": "Whole-school only",
    "folders": "Folders",
    "items": "Materials",
    "noFolders": "No folders here.",
    "empty": {
      "title": "Nothing here yet",
      "staffText": "Upload the first material to start the school library.",
      "filterText": "Nothing matches the current search.",
      "readerText": "Materials your school shares with your classes appear here."
    },
    "open": "Open {{title}}",
    "openFolder": "Open folder {{name}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items",
    "uploadedBy": "Added by {{name}}",
    "root": "Library"
  },
  "upload": {
    "button": "Upload material",
    "title": "Upload material",
    "description": "File type and size are checked automatically when you upload.",
    "fileLabel": "File",
    "filePick": "Choose a file",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Geography atlas, grade 7",
    "authorLabel": "Author",
    "authorPlaceholder": "e.g. O. Petrenko",
    "tagsLabel": "Tags",
    "tagsPlaceholder": "Type a tag and press Enter",
    "tagsHint": "Short keywords that make the material easy to find.",
    "removeTag": "Remove tag {{tag}}",
    "folderLabel": "Folder",
    "noFolder": "No folder",
    "scopeLabel": "Visible to",
    "scopeSchoolWide": "Whole school",
    "progress": "Upload progress",
    "submit": "Upload",
    "success": "Material uploaded",
    "failed": "Could not upload the material"
  },
  "folders": {
    "create": "New folder",
    "createTitle": "New folder",
    "createDescription": "Folders can be nested a few levels deep.",
    "nameLabel": "Name",
    "namePlaceholder": "e.g. Geography",
    "parentLabel": "Inside",
    "noParent": "The library root",
    "scopeLabel": "Visible to",
    "createSubmit": "Create folder",
    "created": "Folder created",
    "rename": "Rename",
    "renameTitle": "Rename folder",
    "renamed": "Folder renamed",
    "delete": "Delete folder",
    "deleteTitle": "Delete {{name}}?",
    "deleteDescription": "Sub-folders are deleted with it. Materials inside are kept and move to the library root.",
    "deleted": "Folder deleted",
    "failed": "Could not save the folder",
    "manage": "Manage folders",
    "actions": "Actions for {{name}}"
  },
  "item": {
    "back": "Back to the library",
    "download": "Download",
    "metadata": "Details",
    "author": "Author",
    "noAuthor": "Unknown",
    "tags": "Tags",
    "noTags": "No tags",
    "scope": "Visible to",
    "folder": "Folder",
    "noFolder": "The library root",
    "size": "Size",
    "type": "Type",
    "added": "Added",
    "addedBy": "Added by",
    "viewerUnavailable": "This file type cannot be shown in the browser. Download it to open it.",
    "pdfTitle": "{{title}} — document viewer",
    "delete": "Delete",
    "deleteTitle": "Delete {{title}}?",
    "deleteDescription": "The material is removed from the library for everyone in the school.",
    "deleted": "Material deleted",
    "notFound": "This material is not available to you."
  },
  "usage": {
    "title": "Storage",
    "line": "{{items}} in the library · {{size}}",
    "itemCount_one": "{{count}} item",
    "itemCount_other": "{{count}} items"
  },
  "validation": {
    "fileRequired": "Choose a file",
    "titleRequired": "Title is required",
    "nameRequired": "Name is required"
  }
}
